import { render, staticRenderFns } from "./Advertise.vue?vue&type=template&id=61baf586&scoped=true"
import script from "./Advertise.vue?vue&type=script&lang=js"
export * from "./Advertise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61baf586",
  null
  
)

export default component.exports